module.exports = __webpack_public_path__ + "img/c2.c8525163.png";